
export * from '../../frontend-taglib-clay/__liferay__/exports/@clayui$color-picker.js';

import __default__ from '../../frontend-taglib-clay/__liferay__/exports/@clayui$color-picker.js';
export default __default__;
